module.exports = __webpack_public_path__ + "2306680ce3c85b0a2994dd3571543dfb.svg";